/* @ngInject */
const wagonFields = (
  wagonLabels,
  $$railway,
  wagonAsk,
  wagonGo,
  $$owner,
  $$area,
  types,
  icons
) => {
  const self = {}

  self.id = {
    ref: 'id',                                  // Field name
    label: wagonLabels.fields.id.text,          // Label displayed into forms or cards
    icon: icons.wagon.id,                       // Icon displayed next to label
    type: types.wagonId,                        // Field type. Usefull for forms
    required: true,                             // If field is required, for forms
    messages: wagonLabels.fields.id.messages,   // Error messages for forms
    output: {                                   // Data concerning display
      sortable: true,                           // true if we can sort by it
      link: true,                               // If we can click and navigate on
      go: wagonGo.consult,                      // Navigate function
      table: { prefill: true, },                // Display on table
      excel: { prefill: true, },                // Display on excel
      select: true,                             // Display on selection array
      class: { 'table-fix-left': true, },       // Classes
    },
  }

  self.idNew = {
    ref: 'idNew',
    label: wagonLabels.fields.idNew.text,
    icon: icons.wagon.idNew,
    type: types.wagonId,
    required: true,
    messages: wagonLabels.fields.idNew.messages,
    output: {
      sortable: true,
      link: true,
      go: wagonGo.consult,
      table: { prefill: true, },
      excel: { prefill: true, },
      select: true,
      details: true,
    },
  }

  self.owner = {
    ref: 'owner',
    label: wagonLabels.fields.owner.text,
    output: {
      sortable: true,
      link: true,
      search: wagonAsk.searchField,
      edit: wagonAsk.editOwner,
      editFields: wagonAsk.editOwners,
      go: $$owner.go.consult,
      table: { prefill: true, },
      excel: { prefill: true, },
      details: true,
    },
  }

  self.ownerId = {
    ref: 'ownerId',
    label: wagonLabels.fields.owner.text,
    icon: icons.wagon.owner,
    type: types.select,
    options: 'owner.id as owner.society for owner',
    order: 'society.toString()',
    messages: wagonLabels.fields.owner.messages,
    required: true,
  }

  self.oldOwner = {
    ref: 'oldOwner',
    label: wagonLabels.fields.oldOwner.text,
    output: {
      sortable: true,
      link: true,
      go: $$owner.go.consult,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.type = {
    ref: 'type',
    label: wagonLabels.fields.type.text,
    icon: icons.wagon.type,
    type: types.text(100),
    messages: wagonLabels.fields.type.messages,
    output: {
      searchable: true,
      search: wagonAsk.searchField,
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  self.set = {
    ref: 'set',
    label: wagonLabels.fields.set.text,
    icon: icons.wagon.set,
    type: types.text(100),
    messages: wagonLabels.fields.id.messages,
    output: {
      sortable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      table: { prefill: true, },
      excel: { prefill: true, },
    },
  }

  self.typeAndSet = {
    ref: 'typeAndSet',
    label: wagonLabels.fields.typeAndSet.text,
    icon: icons.wagon.typeAndSet,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
    },
  }

  self.dateIntervalBegin = {
    ref: 'dateIntervalBegin',
    label: wagonLabels.fields.dateIntervalBegin.text,
    icon: icons.wagon.dateIntervalBegin,
  }

  self.dateIntervalEnd = {
    ref: 'dateIntervalEnd',
    label: wagonLabels.fields.dateIntervalEnd.text,
    icon: icons.wagon.dateIntervalEnd,
  }

  self.area = {
    ref: 'area',
    label: wagonLabels.fields.area.text,
    icon: icons.wagon.area,
    output: {
      sortable: true,
      link: true,
      go: $$area.go.consult,
      table: { prefill: true, },
      excel: { prefill: true, },
      details: true,
    },
  }

  self.railway = {
    ref: 'railway',
    label: wagonLabels.fields.railway.text,
    icon: icons.wagon.railway,
    output: {
      sortable: true,
      link: true,
      go: $$railway.go.consult,
      table: { prefill: true, },
      excel: { prefill: true, },
      select: true,
      details: true,
    },
  }

  self.position = {
    ref: 'position',
    label: wagonLabels.fields.position.text,
    icon: icons.wagon.position,
    type: types.integer,
    messages: wagonLabels.fields.position.messages,
    output: {
      sortable: true,
      excel: { prefill: false, },
      class: { 'fix-number': true, },
    },
  }

  self.ratioPosition = {
    ref: 'ratioPosition',
    label: wagonLabels.fields.ratioPosition.text,
    icon: icons.wagon.position,
    output: {
      table: { prefill: true, },
      excel: { prefill: true, },
      class: { 'fix-number': true, },
      details: true,
      select: true,
    },
  }

  self.trainId = {
    ref: 'trainId',
    label: wagonLabels.fields.trainId.text,
    icon: icons.wagon.trainId,
    output: false,
  }

  self.train = {
    ref: 'train',
    label: wagonLabels.fields.train.text,
    icon: icons.wagon.train,
    output: {},
  }

  self.arrivalDate = {
    ref: 'arrivalDate',
    label: wagonLabels.fields.arrivalDate.text,
    icon: icons.wagon.arrivalDate,
    type: types.date,
    messages: wagonLabels.fields.arrivalDate.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.departureDate = {
    ref: 'departureDate',
    label: wagonLabels.fields.departureDate.text,
    icon: icons.wagon.departureDate,
    type: types.date,
    messages: wagonLabels.fields.departureDate.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.completeRevision = {
    ref: 'completeRevision',
    label: wagonLabels.fields.revision.text,
    icon: icons.wagon.revision,
    output: {
      sortable: true,
      table: { prefill: true, },
      details: true,
    },
  }

  self.completeRevisionExcel = {
    ref: 'completeRevisionExcel',
    label: wagonLabels.fields.revision.text,
    icon: icons.wagon.revision,
    output: {
      excel: { prefill: false, },
    },
  }

  self.revisionDate = {
    ref: 'revisionDate',
    label: wagonLabels.fields.revisionDate.text,
    icon: icons.wagon.revisionDate,
    type: types.date,
    messages: wagonLabels.fields.revisionDate.messages,
    output: {
      sortable: true,
      excel: { prefill: false, },
      table: { prefill: false, },
      searchable: true,
      search: wagonAsk.searchField,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
    },
  }

  self.revisionDateBegin = {
    ref: 'revisionDateBegin',
    label: wagonLabels.fields.revisionDateBegin.text,
    icon: icons.wagon.revisionDate,
    type: types.date,
    messages: wagonLabels.fields.revisionDateBegin.messages,
    output: false,
  }

  self.revisionDateEnd = {
    ref: 'revisionDateEnd',
    label: wagonLabels.fields.revisionDateEnd.text,
    icon: icons.wagon.revisionDate,
    type: types.date,
    messages: wagonLabels.fields.revisionDateEnd.messages,
    output: false,
  }

  self.expiredRevisionDate = {
    ref: 'expiredRevisionDate',
    label: wagonLabels.fields.expiredRevisionDate.text,
    icon: icons.wagon.expiredRevisionDate,
    type: types.date,
    messages: wagonLabels.fields.expiredRevisionDate.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.length = {
    ref: 'length',
    label: wagonLabels.fields.length.text,
    icon: icons.wagon.length,
    type: types.decimal,
    required: true,
    messages: wagonLabels.fields.length.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      select: true,
    },
  }

  self.tare = {
    ref: 'tare',
    label: wagonLabels.fields.tare.text,
    icon: icons.wagon.tare,
    type: types.integer,
    messages: wagonLabels.fields.tare.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editFields: wagonAsk.editFields,
    },
  }

  self.capacity = {
    ref: 'capacity',
    label: wagonLabels.fields.capacity.text,
    icon: icons.wagon.capacity,
    type: types.decimal,
    messages: wagonLabels.fields.capacity.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editFields: wagonAsk.editFields,
    },
  }

  self.brakedMass = {
    ref: 'brakedMass',
    label: wagonLabels.fields.brakedMass.text,
    icon: icons.wagon.brakedMass,
    type: types.integer,
    messages: wagonLabels.fields.brakedMass.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editFields: wagonAsk.editFields,
    },
  }

  self.feet = {
    ref: 'feet',
    label: wagonLabels.fields.feet.text,
    icon: icons.wagon.feet,
    type: types.integer,
    messages: wagonLabels.fields.feet.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editFields: wagonAsk.editFields,
    },
  }

  self.color = {
    ref: 'color',
    label: wagonLabels.fields.color.text,
    icon: icons.wagon.color,
    type: types.text(100),
    messages: wagonLabels.fields.color.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      searchable: true,
      search: wagonAsk.searchField,
      editFields: wagonAsk.editFields,
    },
  }

  self.case = {
    ref: 'case',
    label: wagonLabels.fields.case.text,
    icon: icons.wagon.case,
    type: types.text(255),
    messages: wagonLabels.fields.case.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.status = {
    ref: 'status',
    label: wagonLabels.fields.status.text,
    icon: icons.wagon.status,
    type: types.text(255),
    messages: wagonLabels.fields.status.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.state = {
    ref: 'state',
    label: wagonLabels.fields.state.text,
    icon: icons.wagon.state,
    type: types.text(255),
    messages: wagonLabels.fields.state.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.raadRaat = {
    ref: 'raadRaat',
    label: wagonLabels.fields.raadRaat.text,
    icon: icons.wagon.raadRaat,
    type: types.text(255),
    messages: wagonLabels.fields.raadRaat.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.archive = {
    ref: 'archive',
    label: wagonLabels.fields.archive.text,
    icon: icons.wagon.archive,
    type: types.text(255),
    messages: wagonLabels.fields.archive.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.client = {
    ref: 'client',
    label: wagonLabels.fields.client.text,
    icon: icons.wagon.client,
    type: types.text(255),
    messages: wagonLabels.fields.client.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.comment = {
    ref: 'comment',
    label: wagonLabels.fields.comment.text,
    icon: icons.wagon.comment,
    type: types.textarea,
    messages: wagonLabels.fields.comment.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.elv = {
    ref: 'elv',
    label: wagonLabels.fields.elv.text,
    icon: icons.wagon.elv,
    type: types.text(255),
    messages: wagonLabels.fields.elv.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.vt = {
    ref: 'vt',
    label: wagonLabels.fields.vt.text,
    icon: icons.wagon.vt,
    type: types.text(255),
    messages: wagonLabels.fields.vt.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.workshop = {
    ref: 'workshop',
    label: wagonLabels.fields.workshop.text,
    icon: icons.wagon.workshop,
    type: types.text(255),
    output: {
      sortable: true,
      allEditable: true,
      editFields: wagonAsk.editDispositions,
      editable: true,
      edit: wagonAsk.editDisposition,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
    },
  }

  self.dispositionDate = {
    ref: 'dispositionDate',
    label: wagonLabels.fields.dispositionDate.text,
    icon: icons.date,
    type: types.date,
    required: false,
    output: {
      sortable: true,
      allEditable: true,
      editFields: wagonAsk.editDispositions,
      editable: true,
      edit: wagonAsk.editDisposition,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
    },
  }

  self.isolated = {
    ref: 'isolated',
    label: wagonLabels.fields.isolated.text,
    icon: icons.wagon.isolated,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.isolatedComment = {
    ref: 'isolatedComment',
    label: wagonLabels.fields.isolatedComment.text,
    icon: icons.wagon.isolatedComment,
    type: types.textarea,
    messages: wagonLabels.fields.isolatedComment.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.damaged = {
    ref: 'damaged',
    label: wagonLabels.fields.damaged.text,
    icon: icons.wagon.damaged,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.damagedComment = {
    ref: 'damagedComment',
    label: wagonLabels.fields.damagedComment.text,
    icon: icons.wagon.damagedComment,
    type: types.textarea,
    messages: wagonLabels.fields.damagedComment.messages,
    output: {
      sortable: true,
      editable: true,
      edit: wagonAsk.editField,
      allEditable: true,
      editFields: wagonAsk.editFields,
      searchable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.announceScrapping = {
    ref: 'announceScrapping',
    label: wagonLabels.fields.announceScrapping.text,
    icon: icons.wagon.announceScrapping,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.scrapped = {
    ref: 'scrapped',
    label: wagonLabels.fields.scrapped.text,
    icon: icons.wagon.scrapped,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.scrappingDate = {
    ref: 'scrappingDate',
    label: wagonLabels.fields.scrappingDate.text,
    icon: icons.wagon.scrappingDate,
    type: types.date,
    messages: wagonLabels.fields.scrappingDate.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.sale = {
    ref: 'sale',
    label: wagonLabels.fields.sale.text,
    icon: icons.wagon.sale,
    type: types.text(255),
    messages: wagonLabels.fields.sale.messages,
    output: {
      sortable: true,
      search: wagonAsk.searchField,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.saleId = {
    ref: 'saleId',
    label: wagonLabels.fields.sale.text,
    icon: icons.wagon.sale,
    type: types.select,
    options: 'sale.id as sale.number for sale',
    order: '\'number\'',
    messages: wagonLabels.fields.sale.messages,
  }

  self.saleDate = {
    ref: 'saleDate',
    label: wagonLabels.fields.saleDate.text,
    icon: icons.wagon.saleDate,
    type: types.date,
    messages: wagonLabels.fields.saleDate.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.salePlace = {
    ref: 'salePlace',
    label: wagonLabels.fields.salePlace.text,
    icon: icons.wagon.salePlace,
    type: types.text(255),
    messages: wagonLabels.fields.salePlace.messages,
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.commande = {
    ref: 'commande',
    label: wagonLabels.fields.commande.text,
    icon: icons.wagon.commande,
    output: {
      sortable: true,
      link: true,
      table: { prefill: true, },
      excel: { prefill: true, },
      select: true,
      details: true,
    },
  }

  self.photo = {
    ref: 'photo',
    label: wagonLabels.fields.photo.text,
    icon: icons.wagon.photo,
    type: 'bool',
    output: {
      sortable: true,
      table: { prefill: false, },
      excel: { prefill: false, },
      details: true,
    },
  }

  self.checkScrapping = {
    ref: 'checkScrapping',
    label: wagonLabels.fields.checkScrapping.text,
  }

  return self
}
export default wagonFields



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/resources/fields.resource.js